import React from 'react';
import {
    AlertCircle,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    BookOpen,
    Brain,
    Calendar,
    Check,
    CheckCircle,
    ChevronDown,
    ChevronUp,
    ClipboardList,
    Clock,
    CloudRain,
    Compass,
    ExternalLink,
    Eye,
    Frown,
    Gift,
    Heart,
    HelpCircle,
    Home,
    Infinity,
    Lightbulb,
    Lock,
    Mail,
    Menu,
    MessageCircle,
    MessageSquare,
    Mic,
    Moon,
    RefreshCw,
    Repeat,
    Rocket,
    Send,
    Shield,
    Smile,
    Sparkles,
    Star,
    Stars,
    Sun,
    Sunrise,
    Target,
    Timer,
    TrendingUp,
    User,
    Users,
    X
} from 'lucide-react';

// Explicit map of every icon actually referenced via AppIcon's `name` prop.
// Keeping this list curated (instead of `import * as LucideIcons`) avoids
// pulling the entire lucide-react icon set into the bundle.
const ICONS = {
    AlertCircle,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    BookOpen,
    Brain,
    Calendar,
    Check,
    CheckCircle,
    ChevronDown,
    ChevronUp,
    ClipboardList,
    Clock,
    CloudRain,
    Compass,
    ExternalLink,
    Eye,
    Frown,
    Gift,
    Heart,
    Home,
    Infinity,
    Lightbulb,
    Lock,
    Mail,
    Menu,
    MessageCircle,
    MessageSquare,
    Mic,
    Moon,
    RefreshCw,
    Repeat,
    Rocket,
    Send,
    Shield,
    Smile,
    Sparkles,
    Star,
    Stars,
    Sun,
    Sunrise,
    Target,
    Timer,
    TrendingUp,
    User,
    Users,
    X
};

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const IconComponent = ICONS?.[name];

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;
